var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.wallId)?_c('div',{ref:"wall"},[_c('div',{staticClass:"social-media-wall",attrs:{"data-cfg-wallid":_vm.wallId}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }